require('./api-request');
require('./background-scroll');
require('./custom-modal');
require('./login');
require('./resource-selections');
require('./standards');
require('./content_selection_tabs');
require('./details-preview');
require('./classrooms');
require('./resource-thumbnails');

import { Dropdown } from "bootstrap";

var $loginFlashMessage = $('.login-modal .flash-message');
var $loginFlashMessageContent = $loginFlashMessage.find('div');

const googleLoginForm = document.getElementById('google-login-form');

window.submitLogin = function(form) {
    var $form = $(form);
    $loginFlashMessage.removeClass('show');
    var formData = $form.serialize();

    const apiRequest = () => axios.post(form.action, formData);

    const onSuccess = response => {
        if (response.data.success) {
            window.location.reload(true);
        } else {
            window.location = '/';
        }
    };

    const onError = ({error, openErrorModal}) => {
        if (error.response && error.response.data) {
            $loginFlashMessageContent.html(error.response.data.flash_message);
            $loginFlashMessage.addClass('show alert alert-danger');
            $form.addClass('was-validated hide-feedback');
            $form.find('input[name="passwd"]').val('');
            $form.find('input[name="instructor_code"]').val('').focus();
        } else {
            openErrorModal();
        }

        const $submitButton = $form.find('button[type="submit"]');
        $submitButton.text('Log In');
        $submitButton[0].disabled = false;
    };

    submitApiRequest({apiRequest, onSuccess, onError});

    return false;
};

window.handleGoogleCredentialResponse = function (response) {
    $loginFlashMessage.removeClass('show');

    const apiRequest = () => axios.post(googleLoginForm.action, {
        google_id_token: response.credential,
    });

    const onSuccess = response => {
        if (response.data.success) {
            window.location.reload(true);
        } else {
            window.location = '/';
        }
    };

    const onError = ({error, openErrorModal}) => {
        if (error.response && error.response.data) {
            $loginFlashMessageContent.html(error.response.data.message);
            $loginFlashMessage.addClass('show alert alert-danger');
        } else {
            openErrorModal();
        }
    };

    submitApiRequest({apiRequest, onSuccess, onError});
};

$('#alert-menu')
    .on('show.bs.dropdown', () => {
        if (window.innerWidth <= 535) {
            window.backgroundScroll.disable();
        }
    })
    .on('hide.bs.dropdown', () => {
        if (window.backgroundScroll.isDisabled()) {
            window.backgroundScroll.enable();
        }
    });

$('#alert-menu .close-button-container, #account-menu .close-button-container').click(function () {
    const alertDropdown = new Dropdown(this.closest('.dropdown').querySelector('button[data-bs-toggle]'));
    alertDropdown.toggle();
});

$('#account-menu')
    .on('show.bs.dropdown', () => {
        if (window.innerWidth <= 535) {
            window.backgroundScroll.disable();
        }
    })
    .on('hide.bs.dropdown', () => {
        if (window.backgroundScroll.isDisabled()) {
            window.backgroundScroll.enable();
        }
    });
